<template>
  <div class="wrapper">
    <v-sidebar activeNavItem="inventory"></v-sidebar>

    <div class="main-panel">
      <v-navbar
        v-bind:title="'Inventory'"
        v-bind:path="'/inventory'"
      ></v-navbar>

      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12" v-if="loading">
              <p class="text-center">Loading...</p>
            </div>
            <div class="col-md-12" v-if="!loading && rows.length === 0">
              <p class="text-center">
                You don't currently have any inventory added. Please click add inventory to get started.
              </p>
              <p class="text-center">
                <button
                  class="btn btn-success btn-wd"
                  v-on:click="addInventory()"
                >
                  <i class="fa fa-plus"></i> Add Inventory
                </button>
              </p>
            </div>
            <div class="col-md-12" v-show="!loading && rows.length !== 0">
              <div class="card data-tables">
                <div
                  class="
                    card-body
                    table-no-bordered
                    dataTable
                    dtr-inline
                    table-full-width
                  "
                >
                  <div class="toolbar text-right" style="padding-right: 15px">
                    <!-- Here you can write extra buttons/actions for the toolbar -->
                    <button
                      class="btn btn-success btn-wd"
                      v-on:click="addInventory()"
                    >
                      <i class="fa fa-user"></i> Add Inventory
                    </button>
                  </div>
                  <div class="fresh-datatables">
                    <table
                      id="datatables_inventory"
                      class="table table-condensed"
                      cellspacing="0"
                      width="100%"
                      style="width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>Internal ID</th>
                          <th>Description</th>
                          <th>Rollup Description</th>
                          <th>HTS Code</th>
                          <th>Product Code</th>
                          <th>FDA</th>
                          <th>Num Per Case</th>
                          <th>Price Per Unit</th>
                          <th class="text-right">Actions</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="!loading && rows.length > 0">
            <div class="col-12 text-right">
              <button
                class="btn btn-success btn-wd"
                v-on:click="addInventory()"
              >
                <i class="fa fa-user"></i> Add Inventory
              </button>
            </div>
          </div>
        </div>
      </div>

      <v-footer></v-footer>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import apiService from "../../services/api.service";
import router from "../../router";

import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import Footer from "../../components/AppFooter";

import { checkResponseErrors } from "../../utils/http";

export default {
  name: "InventoryView",
  components: {
    "v-sidebar": Sidebar,
    "v-navbar": Navbar,
    "v-footer": Footer,
  },
  data: () => ({
    rows: [],
    loading: true,
  }),
  async mounted() {
    // builds a table row from an inventory
    const buildRow = (src) => {
      return {
        id: src._id,
        internalId: src.internalId || "",
        description: src.description || "",
        rollupDescription: src.rollupDescription || "",
        unitsPerCase: src.unitsPerCase || "",
        htsCode: src.htsCode || "",
        productCode: src.productCode || "",
        fda: src.fda || "",
        pricePerUnit: src.pricePerUnit || "",
        actions: `
          <a class="btn btn-link btn-info" onclick="editInventory('${src._id}')"><i class="fa fa-fw fa-pencil"></i></a>
          <a class="btn btn-link btn-danger" onclick="deleteInventory('${src._id}', this)"><i class="fa fa-fw fa-trash"></i></a>
        `,
      };
    };

    // empties the rows array to force empty status
    window.emptyTable = () => {
      this.rows = [];
    };

    // fetches rows from server and draws the datatable
    try {
      const resp = await apiService.get("/inventory/getAllItems/");
      if (await checkResponseErrors(resp)) return;
      const body = resp.data;

      if (body.Result && body.Result.length) {
        this.rows = body.Result.map(buildRow);
        initDataTable(this.rows);
      }

      this.loading = false;
    } catch (error) {
      Vue.toasted.error(error, { duration: 3500 });
      return;
    }
  }, // end mounted
  methods: {
    addInventory: () => router.push("/inventory/add"),
  },
};

const initDataTable = (rows) => {
  window.dataTable = $("#datatables_inventory").DataTable({
    data: rows,
    columns: [
      { data: "internalId" },
      { data: "description" },
      { data: "rollupDescription" },
      { data: "htsCode" },
      { data: "productCode" },
      { data: "fda" },
      { data: "unitsPerCase" },
      { data: "pricePerUnit" },
      { data: "actions", className: "text-right" },
    ],
    lengthMenu: [
      [10, 25, 50, -1],
      [10, 25, 50, "All"],
    ],
    order: [[1, "asc"]],
    retrieve: true,
    stateSave: false,
    responsive: {
      details: false,
    },
    language: {
      search: "_INPUT_",
      searchPlaceholder: "Search records",
    },
  });
};

// deletes an inventory
window.deleteInventory = async (id, button) => {
  if (!id) return;

  if (!confirm("Are you sure you want to delete this Inventory?")) return;
  console.log(`deleting inventory: ${id}`);

  try {
    const resp = await apiService.delete(`/inventory/delete/${id}`);
    if (await checkResponseErrors(resp)) return;
  } catch (error) {
    Vue.toasted.error(error, { duration: 3500 });
    return;
  }

  Vue.toasted.success("Successfully Deleted Inventory", { duration: 3500 });

  // removes from datatable and if the tables is empty forces the vue empty state
  dataTable.row($(button).parents("tr")).remove();
  if (dataTable.rows().count() === 0) emptyTable();
  dataTable.draw();
};

// edits an inventory
window.editInventory = (id) => router.push(`/inventory/edit/${id}`);

// show details of an inventory
window.detailInventory = (id) => {
  router.push(`/inventory/${type.toLowerCase()}/details/${id}`);
};
</script>



// WEBPACK FOOTER //
// view.vue?3a8b16c0